module.exports = __webpack_public_path__ + "img/2090a01.svg";